<div class="border-t border-border-secondary w-full flex gap-5 justify-center">
    <div class="p-3 cursor-pointer hover:bg-primary-hover opacity-25"
         [ngClass]="{'opacity-25 cursor-not-allowed': currentPage === 0}"
         (click)="onPageChangeHandler(currentPage - 1)"
    >
        <img class="w-6 h-6" style="transform: rotate(180deg)" src="assets/icons/chevron-right-black.svg" alt="Previous">
    </div>
    <div class="cosentino-pagination flex items-center">
        <!-- First page -->
        <ng-container *ngIf="pages.length > 0">
            <span [class.active]="pages[0] === currentPage"
                  class="border-t-4 border-transparent cursor-pointer typography-body-m-medium px-4 py-3 hover:text-primary hover:bg-primary-hover"
                  (click)="onPageChangeHandler(pages[0])">
                {{pages[0] + 1}}
            </span>
        </ng-container>
        
        <!-- Ellipsis at the start -->
        <span *ngIf="showEllipsisStart" 
              class="typography-body-m-medium px-4 py-3">
            ...
        </span>
        
        <!-- Middle pages -->
        <ng-container *ngFor="let pageNumber of pages; let i = index">
            <ng-container *ngIf="i > 0 && i < pages.length - 1">
                <span [class.active]="pageNumber === currentPage"
                      class="border-t-4 border-transparent cursor-pointer typography-body-m-medium px-4 py-3 hover:text-primary hover:bg-primary-hover"
                      (click)="onPageChangeHandler(pageNumber)">
                    {{pageNumber + 1}}
                </span>
            </ng-container>
        </ng-container>
        
        <!-- Ellipsis at the end -->
        <span *ngIf="showEllipsisEnd" 
              class="typography-body-m-medium px-4 py-3">
            ...
        </span>
        
        <!-- Last page -->
        <ng-container *ngIf="pages.length > 1">
            <span [class.active]="pages[pages.length - 1] === currentPage"
                  class="border-t-4 border-transparent cursor-pointer typography-body-m-medium px-4 py-3 hover:text-primary hover:bg-primary-hover"
                  (click)="onPageChangeHandler(pages[pages.length - 1])">
                {{pages[pages.length - 1] + 1}}
            </span>
        </ng-container>
    </div>
    <div class="p-3 cursor-pointer hover:bg-primary-hover"
         [ngClass]="{'opacity-25 cursor-not-allowed': currentPage === totalPages - 1}"
         (click)="onPageChangeHandler(currentPage + 1)"
    >
        <img class="w-6 h-6" src="assets/icons/chevron-right-black.svg" alt="Next">
    </div>
</div>